import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-grow: 1;
  width: 100%;
`
